export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于我们</h2>
          </div>

          <div className="p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70">
            <div className="flex items-center gap-4 mb-6">
              <span className="w-14 h-14 rounded-2xl bg-primary-500 flex items-center justify-center text-background-50 font-heading text-xl font-bold flex-shrink-0">91</span>
              <div>
                <h3 className="font-heading text-xl font-bold text-foreground-950">91免费</h3>
                <p className="text-sm text-foreground-500">免费看片软件 · 全民共享平台</p>
              </div>
            </div>

            <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>
                91免费成立于2023年，是国内领先的免费看片软件下载与视频资源聚合平台。
                我们致力于为广大用户提供安全、稳定、完全免费的看片app和视频软件，
                覆盖Android、iOS、Windows、Mac全平台。
              </p>
              <p>
                平台核心产品<strong>91免费看片的app</strong>已获得超过3000万用户的信赖，
                日均活跃用户超500万。我们坚持"免费看片，全民共享"的理念，
                通过技术创新持续优化播放体验，智能推荐引擎精准匹配用户口味。
              </p>
              <p>
                91免费软件所有版本均通过严格安全检测，确保用户数据安全与隐私保护。
                未来我们将持续深耕免费视频软件领域，推出更多创新功能，
                让每一位用户都能享受便捷、高清、流畅的免费看片体验。
              </p>
            </div>

            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4">
              <div className="text-center p-3 rounded-lg bg-background-100">
                <div className="font-heading text-lg font-bold text-primary-600">3000万+</div>
                <div className="text-xs text-foreground-500 mt-1">累计用户</div>
              </div>
              <div className="text-center p-3 rounded-lg bg-background-100">
                <div className="font-heading text-lg font-bold text-accent-600">500万+</div>
                <div className="text-xs text-foreground-500 mt-1">日活用户</div>
              </div>
              <div className="text-center p-3 rounded-lg bg-background-100">
                <div className="font-heading text-lg font-bold text-primary-600">4大平台</div>
                <div className="text-xs text-foreground-500 mt-1">全面覆盖</div>
              </div>
              <div className="text-center p-3 rounded-lg bg-background-100">
                <div className="font-heading text-lg font-bold text-accent-600">99.9%</div>
                <div className="text-xs text-foreground-500 mt-1">服务可用率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}